module.exports = __webpack_public_path__ + "assets/shield-be29ab56cd57fa112ce3d0be272eccef.svg";